import { Actions, ActionTypes } from './actions';
import { UserState, initialState } from './state';
import * as AuthActions from 'auth';
import { CapHeaderViewPermissions } from '@cap/cap-ui';

export function userReducer(
    state: UserState = initialState,
    action: Actions | AuthActions.All
) {
    switch (action.type) {
        case AuthActions.AuthActionTypes.GET_USER_INFO_SUCCESS:
            return {
                ...state,
                userName: action.payload.userInfo.username,
                userMemberId: action.payload.userInfo.userCapNumber,
                firstName: action.payload.userInfo.firstName,
                lastName: action.payload.userInfo.lastName,
            };
        case ActionTypes.GET_USER_PERMISSIONS:
            return {
                ...state,
                loading: true,
                loaded: false,
            };
        case ActionTypes.GET_USER_PERMISSIONS_SUCCESS:
            const { isTeamLead, isCAPStaff, isCommitteeMember } = action.payload;

            let viewPermissions: CapHeaderViewPermissions[] = [];
            viewPermissions = isTeamLead ? [...viewPermissions, CapHeaderViewPermissions.TEAM_LEAD] : viewPermissions;

            return {
                ...state,
                loading: false,
                loaded: true,
                isCAPStaff,
                isCommitteeMember,
                elssHeaderItemViewPermissions: viewPermissions,
            };
        default: {
            return state;
        }
    }
}
